import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8506e4a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  class: "page-header-action-item__icon",
  "aria-hidden": "true"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "page-header-action-item__icon-dot" }, null, -1))
const _hoisted_4 = { class: "page-header-action-item__label" }


export default /*#__PURE__*/_defineComponent({
  __name: 'PageHeaderActionItem',
  props: {
    disabled: { type: Boolean, default: false },
    variant: { default: 'default' }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["page-header-action-item", `page-header-action-item--${_ctx.variant}`]),
    role: "menuitem",
    disabled: _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click', $event)))
  }, [
    _createElementVNode("span", _hoisted_2, [
      _renderSlot(_ctx.$slots, "icon", {}, () => [
        _hoisted_3
      ])
    ]),
    _createElementVNode("span", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 10, _hoisted_1))
}
}

})